const pino = require("pino");

const isDev = process.env.NODE_ENV === "development";

module.exports = {
  level: process.env.LOG_LEVEL || (isDev ? "debug" : "info"),
  base: {
    service: process.env.DD_SERVICE || "discover-frontend",
    env: process.env.DD_ENV || process.env.NODE_ENV || "development",
    version: process.env.DD_VERSION,
  },
  // Pino only serializes errors under its default "err" key.
  // This codebase logs them as { error }.
  errorKey: "error",
  serializers: { error: pino.stdSerializers.err },
};
